import { XmaxSdkError } from '../shared/sdk-error'

export const APPLE_MOBILE_VIDEO_CONNECT_TIMEOUT_MS = 35_000
export const APPLE_MOBILE_VIDEO_JOIN_TIMEOUT_MS = 15_000
export const APPLE_MOBILE_VIDEO_SOURCE_TIMEOUT_MS = 8_000
export const APPLE_MOBILE_VIDEO_ENCODER_TIMEOUT_MS = 8_000
export const APPLE_MOBILE_VIDEO_PUBLISH_TIMEOUT_MS = 15_000
export const APPLE_MOBILE_VIDEO_OUTBOUND_TIMEOUT_MS = 10_000
export const APPLE_MOBILE_VIDEO_START_SEND_TIMEOUT_MS = 5_000

export class AppleMobileVideoStageTimeoutError extends XmaxSdkError {
  constructor(message: string) {
    super('WEB_RTC_ERROR', message)
    this.name = 'AppleMobileVideoStageTimeoutError'
  }
}

export async function withAppleMobileVideoStageTimeout<T>(
  operation: () => Promise<T>,
  options: {
    stage: string
    timeoutMs: number
    message: string
  },
): Promise<T> {
  let timeoutId: ReturnType<typeof setTimeout> | null = null
  const timeout = new Promise<never>((_resolve, reject) => {
    timeoutId = setTimeout(() => {
      reject(new AppleMobileVideoStageTimeoutError(
        options.message,
      ))
    }, options.timeoutMs)
  })

  try {
    return await Promise.race([operation(), timeout])
  } finally {
    if (timeoutId !== null) {
      clearTimeout(timeoutId)
    }
  }
}
